export type SnackBarTypes = 'ErrorMessage' | 'NormalMessage';

export interface SnackBarData {
  type: SnackBarTypes;
}

export interface ErrorSnackBarData extends SnackBarData {
  type: 'ErrorMessage';
  message: string;
  params?: string[];
}

export interface SnackBarAction {
  label: string;
  callback: () => void;
}

export interface NormalSnackBarData extends SnackBarData {
  type: 'NormalMessage';
  message: string;
  params?: string[];
  icon?: string;
  actions?: SnackBarAction[];
  /** Overrides the global default (ms). 0 = persist until dismissed. */
  duration?: number;
}

export function isErrorSnackbarData(
  data: SnackBarData
): data is ErrorSnackBarData {
  return data.type === 'ErrorMessage';
}

export function isNormalSnackbarData(
  data: SnackBarData
): data is NormalSnackBarData {
  return data.type === 'NormalMessage';
}
